import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Tag } from '@shared/interfaces/project/tag.interface';
import { Response } from '@shared/models/response.model';
import { Error } from '@shared/interfaces/error.interface';
import { BaseComponent } from '@shared/components/base.component';
import { ProjectService } from '@layouts/default/layouts/logged/pages/project/project.service';
import { PhFiltersAction, PhFiltersService } from './../../ph-filters.service';
import { PhFiltersDataEmitter } from '@shared/components/ph-filters/ph-filters.service';
import { FiltersParams } from '@shared/models/filters/filters-params.model';
import { FilterFeaturedComponent } from '@shared/components/ph-filters/components/filter-featured/filter-featured.component';
import { EventsService } from '@layouts/default/layouts/logged/pages/events/events.service';

@Component({
  selector: 'app-filter-category',
  templateUrl: './filter-category.component.html',
  styleUrls: ['./filter-category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterCategoryComponent extends BaseComponent implements OnInit {
  @Input() correctForm: UntypedFormGroup = null;
  @Input() isEvent: boolean = false;
  @Input() featured: boolean = true;
  @Input() hidePromoted: boolean = false;
  categories: any = [];
  initCategories: any = [];
  selected: number = 0;

  @ViewChild('filterFeatured') filterFeatured: FilterFeaturedComponent;

  constructor(
    private projectService: ProjectService,
    private eventService: EventsService,
    public filtersService: PhFiltersService,
    public changeDetector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.getTags();
    this.correctForm.addControl('filters_category', new UntypedFormGroup({}));
    const langSub = this.languageService.languageEmitter.subscribe((el) => {
      this.getTags();
    });
    this.someSubscriptions.add(langSub);
  }

  get c() {
    return this.correctForm.controls['filters_category']['controls'];
  }

  isNoneSelected() {
    let isAllSelected = true;
    for (const key in this.c) {
      if (!this.c.hasOwnProperty(key)) {
        continue;
      }

      this.c[key].value ? (isAllSelected = false) : null;
    }
    return isAllSelected;
  }

  onCheckboxChange(tag: Tag) {
    this.c[tag.id].value ? this.selected++ : this.selected--;
    if (this.selected >= 4) {
      for (const key in this.c) {
        if (!this.c.hasOwnProperty(key)) {
          continue;
        }

        this.c[key].patchValue(false, { emitEvent: false });
      }
      this.selected = 1;
      this.c[tag.id].patchValue(true, { emitEvent: false });
    }
    this.updateParams();
  }

  resetCategory() {
    this.filtersService.params.filters_category = '';
    for (const key in this.c) {
      if (!this.c.hasOwnProperty(key)) {
        continue;
      }
      this.c[key].patchValue(false, { emitEvent: false });
    }
    this.selected = 0;
    this.updateParams();
    this.changeDetector.detectChanges();
  }

  getTags() {
    const subTag = this.projectService.tagList().subscribe((res: Response<Tag[]>) => {
      this.categories = res.data;
      if (this.categories.length > 0) {
        setTimeout(this.checkUrlParams.bind(this));
      }
      this.changeDetector.markForCheck();
    }, this.onTagError.bind(this));
    this.someSubscriptions.add(subTag);
  }

  onTagError(error: Error) {
    this.toast.error(
      this.translate.instant('ACCOUNT.tag_cant_get'),
      this.translate.instant('ACCOUNT.tag_error')
    );
  }

  updateParams() {
    this.filtersService.filtersEmitter.emit(
      new PhFiltersDataEmitter({
        action: PhFiltersAction.UPDATE_PARAMS,
        params: this.getFiltersCategoryParams(),
      })
    );
  }

  getFiltersCategoryParams() {
    const categories = [];
    for (const key in this.c) {
      if (!this.c.hasOwnProperty(key)) {
        continue;
      }
      if (this.c[key].value) {
        categories.push(key);
      }
    }
    return { filters_category: categories.length > 0 ? categories : '', page: 1 };
  }

  checkUrlParams() {
    const params: FiltersParams = this.filtersService.params;
    if (params.filters_category) {
      let categories: any = params.filters_category;
      !Array.isArray(categories) ? (categories = params.filters_category.split(',')) : null;
      categories.map((id: string) => {
        this.c[id] ? this.c[id].patchValue(true, { emitEvent: false }) : null;
      });
      this.initCategories = categories;
      this.selected = this.initCategories.length;
      this.changeDetector.detectChanges();
    }
  }

  getInitCategories(id) {
    return this.initCategories.find((el) => +el === id);
  }
}
